module.exports = __webpack_public_path__ + "static/media/Food Nutrition Facts.ca0a4697.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Food Nutrition Facts.png
// module id = 418
// module chunks = 0